// extracted by mini-css-extract-plugin
export default {"container":"styles_container__cnpT0","paragraph":"styles_paragraph__s307i"};